var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "filter" },
    [
      _c(
        "transition",
        { attrs: { name: "slide-fade", duration: { enter: 500, leave: 0 } } },
        [
          _c(
            "div",
            { staticClass: "filterContainer" },
            [
              _c("h3", [_vm._v("Filter by Product Category:")]),
              _c("br"),
              _c("label", [
                _vm._v(" All "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedCat,
                      expression: "selectedCat",
                    },
                  ],
                  attrs: { type: "radio", value: "All" },
                  domProps: { checked: _vm._q(_vm.selectedCat, "All") },
                  on: {
                    change: function ($event) {
                      _vm.selectedCat = "All"
                    },
                  },
                }),
              ]),
              _vm._l(_vm.cat, function (c) {
                return _c("div", [
                  _c("label", [
                    _vm._v(" " + _vm._s(c) + " "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedCat,
                          expression: "selectedCat",
                        },
                      ],
                      attrs: { type: "radio" },
                      domProps: {
                        value: c,
                        checked: _vm._q(_vm.selectedCat, c),
                      },
                      on: {
                        change: function ($event) {
                          _vm.selectedCat = c
                        },
                      },
                    }),
                  ]),
                ])
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }